import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  TooltipItem,
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import type { DeviceCategory, BrowserData } from '../../lib/types'

ChartJS.register(ArcElement, Tooltip, Legend)

interface DeviceViewportChartProps {
  viewports: DeviceCategory[]
  browsers: BrowserData[]
}

const COLORS = [
  'hsl(222.2, 47.4%, 11.2%)',
  'hsl(222.2, 47.4%, 30%)',
  'hsl(215.4, 16.3%, 46.9%)',
  'hsl(210, 40%, 60%)',
  'hsl(200, 50%, 50%)',
]

export function DeviceViewportChart({ viewports }: DeviceViewportChartProps) {
  const chartData = {
    labels: viewports.map((d) => d.device_category),
    datasets: [
      {
        data: viewports.map((d) => d.events),
        backgroundColor: viewports.map((_, i) => COLORS[i % COLORS.length]),
        borderWidth: 2,
        borderColor: 'white',
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<'doughnut'>) => {
            const item = viewports[context.dataIndex]
            const total = viewports.reduce((sum, v) => sum + v.events, 0)
            const percentage = ((item.events / total) * 100).toFixed(1)
            return `${item.events.toLocaleString()} events (${percentage}%)`
          },
        },
      },
    },
  }

  return (
    <div className="h-[300px]">
      <Doughnut data={chartData} options={options} />
    </div>
  )
}
